<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          </a-col>
        </a-row>
        <a-form-item label="PP Detail">
          <a-select
              showSearch
              allowClear
              v-decorator="['selectedPPdtl', {rules: [{required: true}], initialValue: undefined}]"
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in ppdetillist"
                :key="item.id_pp_dtl"
              >
              <div class="elipsdiv">
                <div class="elipsdiv-mouseover-label1" >
                  {{ item.nama_barang }} - {{ item.kode_anggaran }}</div>
                <div class="elipsdiv-mouseover-label2">
                    <b style="float: right">{{
                        formatCurrency(item.currency,parseFloat(item.nilai_dtl_pp))
                      }}
                    </b>
                </div>
              </div>
              <!-- <table style="width:100%">
                <tr>
                  <td>
                    <span> {{item.nama_barang}} - {{item.kode_anggaran}}</span>
                  </td>
                  <td>
                    <b style="float:right">&nbsp;&nbsp;&nbsp;{{formatCurrency(item.currency,parseFloat(item.nilai_dtl_pp))}} </b>
                  </td>
                </tr>
              </table> -->
              </a-select-option>
            </a-select>
        </a-form-item>
        <a-form-item label="Name Item">
          <a-input autocomplete="off" v-decorator="['item_name', {rules: [{required: true}]}]"></a-input>
        </a-form-item>
        <a-form-item label="Value">
          <a-input-number
            :min="0"
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="value => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="['value', {rules: [{required: true},{validator:checkPrice}]}]"
            @change="convertingqty"
          />
        </a-form-item>
        <p v-if="mata_uang!=='IDR'" class="margin-bottom">Total value to IDR: {{convert_value}}<br/></p>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button @click="handleNewItem" :loading="newLoading" block type="primary" html-type="submit">Add</a-button>
        </a-form-item>
      </a-col>

      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div slot="header">
              <h4 class="margin-remove">Purchase List</h4>
            </div>
            <a-table
              v-if="!getScreen"
              :columns="columns"
              :dataSource="getCountWeb"
              :pagination="pagination"
              size="small"
              :scroll="{ x: 600}"
              bordered
            >
              <span slot="item_name" slot-scope="item_name">
                {{item_name.item_name}}<br/>
                <b>{{item_name.pp_nama_barang}}</b><br/>
                <i>{{item_name.pp_kode_anggaran}}</i>
              </span>
              <span slot="unit_price" slot-scope="unit_price">
                <CurrencyJustified
                  v-if="unit_price.val"
                  :currencyValue="unit_price.curr"
                  :valueNumber="unit_price.val"
                />
                <div v-else style="text-align:center;width:100%">-</div>
              </span>
              <span slot="amount" slot-scope="amount">
                <CurrencyJustified
                  v-if="amount.val"
                  :currencyValue="amount.curr"
                  :valueNumber="amount.val"
                />
                <div v-else style="text-align:center;width:100%">-</div>
              </span>
              <template slot="operation" slot-scope="index,item">
                <a-button-group v-if="item">
                  <a-button type="primary" @click="handleEditModal(item)">
                    <a-icon type="edit" />
                  </a-button>
                  <a-button type="danger" @click="handleRemove(item)">
                    <a-icon type="close" />
                  </a-button>
                </a-button-group>
              </template>
            </a-table>
            <a-list v-else itemLayout="vertical" :dataSource="listUMPP" :pagination="pagination">
              <Empty v-if="listUMPP ? listUMPP.length<=0 : listUMPP" />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">{{item.item_name ? item.item_name : item.values.item_name}}</span>
                  <div slot="description" class="margin-remove">
                    <div class="m-display-flex space-between">
                      <span>&nbsp;</span>
                      <!-- <div>
                        <h4
                          class="margin-remove m-text-align right"
                        >@ {{formatCurrency(mata_uang,item.value ? item.value : item.values.value)}}</h4>
                      </div> -->
                    </div>
                    <a-divider class="margin-small" />
                    <h4
                      class="margin-remove m-text-align right"
                    >{{formatCurrency(mata_uang,item.value ? item.value : item.values.value)}}</h4>
                  </div>
                </a-list-item-meta>
                <a-button-group>
                  <a-button @click="handleEditModal(item)" type="primary">
                    <a-icon type="edit" />&nbsp;Edit
                  </a-button>
                  <a-button
                    @click="handleRemove(item)"
                    type="danger"
                  >
                    <a-icon type="close" />&nbsp;Remove
                  </a-button>
                </a-button-group>
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>
        <div class="m-price-total">
          <a-statistic
            title="Grand Total"
            :value="formatCurrency(matauang(), grandTotal)"
            class="margin-top m-text-align right"
          />
        </div>
      </a-col>
    </a-row>

    <a-modal v-model="editModal" :key="editData.item_name" :footer="null"
      @cancel="handleClose" :maskClosable="false">
      <span slot="title">
        <a-icon type="reload" />&nbsp;Change Work
      </span>

      <a-form :form="modalForm">
        <a-form-item label="PP Detail">
          <a-select
              showSearch
              allowClear
              v-decorator="['selectedPPdtl', {rules: [{required: true}], initialValue: editData.selectedPPdtl}]"
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in ppdetillist"
                :key="item.id_pp_dtl"
                :value="item.id_pp_dtl"
              >
              <!-- <table style="width:100%">
                <tr>
                  <td>
                    <span> {{item.nama_barang}} - {{item.kode_anggaran}}</span>
                  </td>
                  <td>
                    <b style="float:right">&nbsp;&nbsp;&nbsp;{{formatCurrency(item.currency,parseFloat(item.nilai_dtl_pp))}} </b>
                  </td>
                </tr>
              </table> -->
              <div class="elipsdiv">
                <div class="elipsdiv-mouseover-label1" >
                  {{ item.nama_barang }} - {{ item.kode_anggaran }}</div>
                <div class="elipsdiv-mouseover-label2">
                    <b style="float: right">{{
                        formatCurrency(item.currency,parseFloat(item.nilai_dtl_pp))
                      }}
                    </b>
                </div>
              </div>
              </a-select-option>
            </a-select>
        </a-form-item>
        <a-form-item label="Name Item">
          <a-input
            autocomplete="off"
            v-decorator="['item_name', {rules: [{required: true}], initialValue: editData.item_name}]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Value">
          <a-input-number
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="value => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="['value', {rules: [{required: true},{validator:checkPrice}], initialValue: editData.value}]"
            @change="convertingmodalqty"
          />
        </a-form-item>
        <p v-if="mata_uang!=='IDR'" class="margin-bottom">Total value to IDR: {{modalconvert_value}}<br/></p>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleModalEdit(editData.key)"
            block
            type="danger"
            html-type="submit"
          >Change</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import axios from "axios";
import _ from "lodash";

export default {
  name: "DetailUMPP",
  mixins: [CurrencyFormat],
  props: {
    id: String,
    data: {},
    listUMPP: {},
    mode: String,
    mata_uang: String,
    kurs: String,
  },
  data() {
    return {
      editModal: false,
      editData: {
        values: {
          id_wo_dtl: "",
          item_name: "",
          jumlah: 0,
          satuan: "",
          value: 0,
        },
      },
      pagination: {
        onChange: () => {},
        pageSize: 5,
        size: "small",
      },
      satuan: [],
      form: this.$form.createForm(this),
      push: [],
      newLoading: false,
      ppdetillist: [],
      convert_value: 0,
      modalconvert_value: 0,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
    this.formUpload = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getScreen", "getSatuan", "getAuth"]),
    initialData() {
      if (this.listUMPP === undefined || this.listUMPP.length <= 0) {
        return {
          id_wo_dtl: "",
          item_name: "",
          jumlah: 0,
          satuan: "",
          value: 0,
        };
      } else {
        return {
          id_wo_dtl: this.listUMPP.id_wo_dtl,
          item_name: this.listUMPP.item_name,
          jumlah: this.listUMPP.jumlah,
          satuan: this.listUMPP.satuan,
          value: this.listUMPP.value,
        };
      }
    },
    initialList() {
      let outputList = [];
      if (this.listUMPP.length >= 1) {
        outputList = this.listUMPP;
      }

      return outputList;
    },
    totalPrice() {
      let total = 0;
      this.listUMPP.forEach((item) => {
        total = total + item.value;
      });

      return total;
    },
    initialSatuan() {
      let satuan = [];
      this.getSatuan.forEach((item) => {
        satuan.push(item["id"]);
      });

      return satuan;
    },
    grandTotal() {
      return (
        this.totalPrice
      );
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 50,
          sorter: (a, b) => a.no - b.no,
          fixed: "left",
        },
        {
          title: "PP Detail",
          // dataIndex: "item_name",
          width: 350,
          key: "item_name",
          scopedSlots: { customRender: "item_name" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Value",
          dataIndex: "unit_price",
          key: "unit_price",
          width: 200,
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 110,
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      let data = this.listUMPP
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] =value.item_name;
          data[index]["unit_price"] = {
            curr: value.mata_uang,
            val: value.value,
          };
          data[index]["no"] = index + 1;
          data[index]["key"] = index + 1;
          data[index]["pp_kode_anggaran"] = value.pp_kode_anggaran
          data[index]["pp_nama_barang"] = value.pp_nama_barang
          data[index]["selectedPPdtl"] = value.selectedPPdtl
          data[index]["mata_uang"] = value.mata_uang
        });
      }
      return data;
    },
  },
  mounted() {
    Event.$on("confirmMessageDelete", this.delete);
  },
  activated(){
    this.fetchAttribute()
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.delete);
  },
  methods: {
    convertingqty(val){
      this.convert_value = parseFloat(val)*parseFloat(this.kurs)
    },
    convertingmodalqty(val){
      this.modalconvert_value = parseFloat(val)*parseFloat(this.kurs)
    },
    matauang(){
      let hasil = ""
      if(this.listUMPP[0]){
        hasil = this.listUMPP[0].mata_uang
      }
      return hasil
    },
    isObject(obj) {
      return obj === Object(obj);
    },
    simulation(arr,idppdtl){
      let result = true
      if(this.ppdetillist.length>0){
        for (let index = 0; index < this.ppdetillist.length; index++) {
            this.ppdetillist[index].temp_nilai_dtl_pp = this.ppdetillist[index].nilai_dtl_pp_origin
          }
      }
      
      if(arr.length>0){
        arr.forEach(ment => {
          let ppdtl=ment.selectedPPdtl
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem==ppdtl){
                this.ppdetillist[index].temp_nilai_dtl_pp = 
                parseFloat(this.ppdetillist[index].temp_nilai_dtl_pp) - parseFloat(ment.value)
                break
            }
          }
        });
      }
      //console.log("this.ppdetillist",this.ppdetillist)
      this.ppdetillist.forEach(element => {
        if (parseFloat(element.temp_nilai_dtl_pp) < 0 && idppdtl == element.id_pp_dtl){
          result = false
        }
      });
      return result
    },
    recountingBalance(arr){
      if(this.ppdetillist.length>0){
        for (let index = 0; index < this.ppdetillist.length; index++) {
            this.ppdetillist[index].nilai_dtl_pp = this.ppdetillist[index].nilai_dtl_pp_origin
          }
      }
      
      if(arr.length>0){
        arr.forEach(ment => {
          let ppdtl=ment.selectedPPdtl
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem==ppdtl){
                this.ppdetillist[index].nilai_dtl_pp = 
                parseFloat(this.ppdetillist[index].nilai_dtl_pp) - parseFloat(ment.value)
                break
            }
          }
        });
      }
    },
    handleClose(){
      this.recountingBalance(this.listUMPP)
      this.modalForm.resetFields();
    },
    fetchAttribute(){
      this.form.resetFields()
      let dataParams = this.mode == "Edit" ?
      {
        id_pp : this.data.id_pp,
        id_um : this.id
      } : {
        id_pp : this.data.id_pp
      }
      const ppdetil = axios({
        method: "get",
        params: dataParams,
        url: this.$serviceUrl + "pp/nama_item",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      return axios
        .all([
          ppdetil.catch(err => {
            console.log(err);
            return null;
          }),
        ])
        .then(response => {
          if (response[0] !== undefined) {
            this.ppdetillist = response[0].data.list_nama_item;
            if (this.listUMPP.length>0){
              this.recountingBalance(this.listUMPP)
            }
          } else {
            this.ppdetillist = [];
          }
        })
        .catch(err => {
          console.log(err);
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
          // this.pageLoading = false;
        });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
      return false;
    },
    handleRemoveList(file) {
      const index = this.push.indexOf(file);
      const newFileList = this.push.slice();
      newFileList.splice(index, 1);
      this.push = newFileList;
    },
    handleDownload() {
      axios({
        method: "get",
        url: this.$serviceUrl + "/main/download_template_wo?X-API-KEY=xxx",
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          window.open(this.$serviceUrl + response.data.url, "_blank");
        })
        .catch((err) => {
          console.log(err)
          this.displayMessage("error-emptyDocTemplate");
        });
    },
    handleRef() {
      if (this.listUMPP.length <= 0) {
        this.displayMessage("more-content");
      } else {

        Event.$emit("umppData", { Detail: this.listUMPP, informasi: this.data, grandtotal:this.grandTotal });
      }
    },
    handleNewItem() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          this.newLoading = false;
          return;
        }
        this.newLoading = true;
        let findName = []
        if (this.listUMPP.length>0){
          findName = this.listUMPP.filter(
            (item) => item.item_name === values.item_name &&
              item.selectedPPdtl == values.selectedPPdtl
          );
        }
        if (findName.length > 0) {
          this.displayMessage("data-exist");
          this.newLoading = false;
          return;
        } else {

          let datadtlPP = _.filter(
          this.ppdetillist,
          (obj) =>
            obj.id_pp_dtl &&
            obj.id_pp_dtl
              .toLowerCase() == values.selectedPPdtl.toLowerCase()
        );

        //validasi value entri
        let plafon = 0
        let vmsk = values.value
        this.ppdetillist.forEach(element => {
          if (element.id_pp_dtl == values.selectedPPdtl){
            plafon = parseFloat(element.nilai_dtl_pp)
          }
        });

          values.pp_nama_barang = datadtlPP[0].nama_barang
          values.pp_kode_anggaran = datadtlPP[0].kode_anggaran
          values.hargaTotal = values.value;
          values.mata_uang=datadtlPP[0].currency;

        if ((vmsk> plafon && (this.totalPrice==0 ? values.hargaTotal : this.totalPrice)-vmsk<0.1)) {
          this.newLoading = false;
          this.displayMessage("grather-remaining");
          return;
        }
          let isthis = [...this.listUMPP, JSON.parse(JSON.stringify({ 
            key: "other",selectedPPdtl : values.selectedPPdtl
            ,value : values.value
            , values  
            }))];
          //console.log("isthis",isthis)
          if (!this.simulation(isthis,values.selectedPPdtl)){
            this.displayMessage("grather-remaining");
            this.newLoading = false;
            return;
          }
          Event.$emit("listUMPP", { values });

          this.form.resetFields();
          this.convert_value = 0;
          this.displayMessage("success-add");
          this.newLoading = false;
        }
      });
    },
    handleRemove(item) {
      //console.log(item,this.listUMPP)
      const newPush = this.listUMPP.filter(
              (valu) => valu.item_name.concat(valu.selectedPPdtl) !== item.item_name.concat(item.selectedPPdtl)
            );
      if (!this.simulation(newPush,item.selectedPPdtl)){
        this.displayMessage("grather-remaining");
        this.newLoading = false;
        return;
      }

      this.confirmMessageValue("confirm-delete", item, null);
    },
    delete(val) {
      if (val){
        const newPush = this.listUMPP.filter(
          (item) => item.item_name.concat(item.selectedPPdtl) !== val.item_name.concat(val.selectedPPdtl)
        );
        //this.modalForm.resetFields();

        // const dataItem = item.toString();
        // const index = this.listUMPP.indexOf(item.toString());
        // const newPush = this.listUMPP.filter(
        //   (item) => item.values.item_name !== dataItem
        // );
        this.editData = [];
        Event.$emit("updateList", newPush);
      }
    },
    handleEditModal(item) {
      this.editData = item;
      //console.log(this.editData)
      this.editModal = !this.editModal;

      this.modalconvert_value = this.formatRupiah(item.value*parseFloat(this.kurs))

      if(this.ppdetillist.length>0){
        for (let index = 0; index < this.ppdetillist.length; index++) {
          const elem = this.ppdetillist[index].id_pp_dtl;
          if (elem==item.selectedPPdtl){
            this.ppdetillist[index].nilai_dtl_pp = parseFloat(this.ppdetillist[index].nilai_dtl_pp)+
              item.value
            break
          }            
        }
      }
    },
    handleModalEdit(id_key) {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.isObject(this.selectedPNm)){
          this.selectedPNm = this.selectedPNm.item_pn;
        }
        let exist = _.filter(
        this.listUMPP,
        (obj) =>
          obj.selectedPPdtl &&
          obj.selectedPPdtl.toLowerCase() == values.selectedPPdtl.toLowerCase() &&
          obj.item_name &&
          obj.item_name
            .toLowerCase()
             == values.item_name.toLowerCase()
        );
        
        if (exist.length > 0 && exist[0].key!==this.editData.key){
          this.displayMessage("form-duplicate");
          this.modalForm.resetFields()
          return;
        }

        //validasi value entri
          let plafon = 0
          this.ppdetillist.forEach(element => {
            if (element.id_pp_dtl == values.selectedPPdtl){
              plafon = parseFloat(element.nilai_dtl_pp)
            }
          });

          if (values.value > plafon) {
            this.newLoading = false;
            this.displayMessage("grather-remaining");
            this.modalForm.resetFields()
            // this.$nextTick(function () {
            //   this.modalForm.setFieldsValue({
            //     harga: null,
            //   });
            // });
            return;
          }

          let datadtlPP = _.filter(
            this.ppdetillist,
            (obj) =>
              obj.id_pp_dtl &&
              obj.id_pp_dtl
                .toLowerCase() == values.selectedPPdtl.toLowerCase()
          );
          values.pp_nama_barang = datadtlPP[0].nama_barang
          values.pp_kode_anggaran = datadtlPP[0].kode_anggaran
          values.mata_uang = datadtlPP[0].currency

          if (this.isObject(this.selectedPN)){
            this.selectedPN = this.selectedPN.item_pn;
          }
          values.item_pn = this.selectedPNm;
          const newPush = this.listUMPP.filter(
            (item) => item.key !== id_key
          );

          let isthis = [...newPush, JSON.parse(JSON.stringify({ 
            key: "other",selectedPPdtl : values.selectedPPdtl
            ,value : values.value
            , values   }))];
            if (!this.simulation(isthis,values.selectedPPdtl)){
              this.displayMessage("grather-remaining");
              this.modalForm.resetFields()
              this.newLoading = false;
              return;
            }

          Event.$emit("updateList", newPush);

          //mengembalikan value ke value asli terlebih dahulu sebelum recalculate
          if(this.listUMPP.length>0){
            this.listUMPP.forEach(element => {
              for (let index = 0; index < this.ppdetillist.length; index++) {
                const elem = this.ppdetillist[index].selectedPPdtl;
                if (elem==element.id_pp_dtl){
                  this.ppdetillist[index].nilai_dtl_pp = this.ppdetillist[index].nilai_dtl_pp_origin
                  break
                }            
              }
            });
          }
          if (this.mode=="Edit" && this.editData.id_um_dtl){
            values.id_um_dtl = this.editData.id_um_dtl
          }
          values.hargaTotal = values.value;
          Event.$emit("listUMPP", { values});
          this.editModal = !this.editModal;
          this.modalconvert_value = 0;
          this.displayMessageValue('update-item',values.item_name);
          this.editData = []
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    filterOption(input, option) {
      //console.log(option)
      return (
        option.componentOptions.children[0].children[0].elm.innerText.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style lang="less">
.footer-list {
  display: flex;
  justify-content: flex-end;
  .ant-row{
    width: 100%;

  }
}
.footer-light{
  font-size: medium;
}
</style>